import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllSourcesRedux = createAsyncThunk(
    "sources/getAllSources",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/sources?active=0`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getJsSourcesRedux = createAsyncThunk(
    "sources/getJsSources",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/sources?active=0&type=js`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getSourceForAddingTrackers = createAsyncThunk(
    "sources/getExistSources",
    async (trackerId) => {
        const response = await axios.get(
            `${baseURL}/api/sources?active=0&tracker_id=${trackerId}`,
            RequestConfig(),
        );
        return response.data;
    },
);
